(() => {
  const controllers = new Map();
  document.addEventListener('wd:bundle:added', async () => {
    try {
      const cart = await window.theme.cart.getCart();
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart count');
      window.theme.CartForm.prototype.updateCount(cart.item_count);
      document.querySelectorAll('.cart-link__bubble').forEach(bubble => {
        if (!bubble.querySelector('.cart-link__bubble-num')) bubble.textContent = String(cart.item_count);
      });
    } catch (error) {
      console.error('Unable to refresh bundle cart count', error);
    }
  });
  function mount(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    const sticky = root.querySelector('[data-atelier-sticky]');
    const buyBlock = root.querySelector('.product-block-buy-button');
    const primary = buyBlock?.querySelector('.wd-atc, [data-add-to-cart]');
    if (!sticky || !buyBlock || !primary) return;
    const observer = new IntersectionObserver(entries => {
      sticky.hidden = entries[0].isIntersecting;
    }, { threshold: 0 });
    observer.observe(buyBlock);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
    }).format(cents / 100);
    function syncSelection() {
      const form = root.querySelector('[data-bundle-size]');
      if (form) {
        const selected = [...form.querySelectorAll('input[type="radio"]:checked')];
        root.querySelectorAll('[data-atelier-size-for]').forEach(label => {
          const choice = selected.find(input => input.name.endsWith(`-${label.dataset.atelierSizeFor}`));
          label.textContent = choice?.dataset.title || 'Größe wählen';
          label.closest('.atelier-piece').classList.toggle('is-selected', !!choice);
        });
        const complete = [...form.querySelectorAll('[data-bss-group]')].every(group => group.querySelector('input:checked'));
        const sum = selected.reduce((total, input) => total + Number(input.dataset.cents || 0), 0);
        const stickyPrice = sticky.querySelector('[data-atelier-sticky-price]');
        stickyPrice.textContent = complete ? money(sum) : 'Wähle deine Größen';
      } else {
        const price = root.querySelector('[data-product-price]');
        if (price) sticky.querySelector('[data-atelier-sticky-price]').textContent = price.textContent;
      }
    }
    root.addEventListener('change', syncSelection, { signal: controller.signal });
    root.addEventListener('variantChange', syncSelection, { signal: controller.signal });
    sticky.querySelector('button').addEventListener('click', () => {
      const restock = root.querySelector('[data-restock-trigger]');
      if (restock && !restock.hidden) {
        buyBlock.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (restock.getAttribute('aria-expanded') !== 'true') restock.click();
      } else if (primary.matches('.wd-atc') && !primary.disabled && primary.getClientRects().length) {
        primary.click();
      } else {
        const target = root.querySelector('.variant-wrapper') || buyBlock;
        target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const focus = target.querySelector('input:not(:disabled), select:not(:disabled), button:not(:disabled)');
        focus?.focus({ preventScroll: true });
      }
    }, { signal: controller.signal });
    syncSelection();
    controllers.set(root, () => { observer.disconnect(); controller.abort(); });
  }
  function scan(scope) {
    if (scope.matches?.('[data-atelier-pdp]')) mount(scope);
    scope.querySelectorAll('[data-atelier-pdp]').forEach(mount);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of controllers) {
      if (event.target.contains(root)) { dispose(); controllers.delete(root); }
    }
  });
})();